// extracted by mini-css-extract-plugin
export var sbShowMain = "socialMedia-module--sb-show-main--AOWij";
export var socialList = "socialMedia-module--socialList--gZF3j";